import React from 'react';
import { Leaf, Wind, Recycle } from 'lucide-react';
import { whyBio } from '../mock';

const iconMap = { Leaf, Wind, Recycle };

const WhyBio = () => {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 grid lg:grid-cols-2 gap-14 items-center">
        <div>
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-emerald-200 bg-emerald-50 text-emerald-700 text-xs font-semibold uppercase tracking-widest">
            <Leaf className="w-3.5 h-3.5" /> Why Renewable Energy?
          </div>
          <h2 className="mt-5 text-4xl md:text-5xl font-extrabold leading-tight text-[#0b1a1a]">
            Why use <span className="text-emerald-600">Bio Fuels?</span>
          </h2>
          <p className="mt-5 text-slate-600 leading-relaxed text-lg">
            Biofuels like Compressed Biogas (CBG) bring major benefits for the environment and society. Produced from renewable resources such as agricultural waste, food waste, and organic materials, CBG is a clean and sustainable alternative to fossil fuels.
          </p>

          <div className="mt-8 space-y-5">
            {whyBio.map((w) => {
              const Icon = iconMap[w.icon];
              return (
                <div key={w.title} className="flex gap-4">
                  <div className="w-12 h-12 shrink-0 rounded-2xl bg-emerald-50 border border-emerald-100 grid place-items-center">
                    <Icon className="w-5 h-5 text-emerald-600" />
                  </div>
                  <div>
                    <h4 className="font-bold text-[#0b1a1a]">{w.title}</h4>
                    <p className="text-slate-600 text-sm mt-1 leading-relaxed">{w.desc}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        <div className="grid grid-cols-2 gap-4 h-[560px]">
          <div className="relative rounded-3xl overflow-hidden shadow-lg">
            <img src="https://images.pexels.com/photos/32543708/pexels-photo-32543708.jpeg"
                 alt="Bio fuel production" className="w-full h-full object-cover" />
          </div>
          <div className="flex flex-col gap-4">
            <div className="relative rounded-3xl overflow-hidden shadow-lg flex-1">
              <img src="https://images.pexels.com/photos/414905/pexels-photo-414905.jpeg"
                   alt="Wind energy" className="w-full h-full object-cover" />
            </div>
            <div className="relative rounded-3xl bg-gradient-to-br from-emerald-500 to-emerald-700 p-6 text-white flex flex-col justify-end shadow-lg h-44">
              <div className="text-4xl font-extrabold">98%</div>
              <div className="text-sm font-semibold uppercase tracking-wider opacity-90 mt-1">Lower emissions</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyBio;
